import React from "react";
import { Badge, Box, SimpleGrid, Stack, Text } from "@chakra-ui/react";

const currency = (value) => new Intl.NumberFormat("en-NG", {
  style: "currency",
  currency: "NGN",
  minimumFractionDigits: 2,
}).format(Number(value) || 0);

const PrescriptionItemsDisplay = ({ items = [] }) => (
  <Stack spacing="2">
    {items.map((item, index) => (
      <Box key={`${item.drug}-${index}`} borderWidth="1px" borderColor="gray.200" borderRadius="lg" p="3" bg="white">
        <Text fontWeight="800">{item.drug}</Text>
        <Text mt="1" fontSize="sm" color="gray.600">{item.dosage}</Text>
        <SimpleGrid columns={{ base: 1, sm: 3 }} gap="2" mt="3">
          <Box><Text fontSize="xs" color="gray.500">Amount</Text><Text fontWeight="700">{currency(item.amount)}</Text></Box>
          <Box><Text fontSize="xs" color="gray.500">Discount</Text><Badge>{Number(item.discount) || 0}%</Badge></Box>
          <Box><Text fontSize="xs" color="gray.500">Total</Text><Text fontWeight="800" color="brand.700">{currency(item.totalAmount)}</Text></Box>
        </SimpleGrid>
      </Box>
    ))}
  </Stack>
);

export default PrescriptionItemsDisplay;
